import { render } from "./TodaysSchedule.vue?vue&type=template&id=c8f1ff10"
import script from "./TodaysSchedule.vue?vue&type=script&lang=js"
export * from "./TodaysSchedule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__